<template>
  <router-view class="view"/>
</template>

<script>

export default {}
</script>

<style lang="scss">
@import '~style/variables';

</style>



// WEBPACK FOOTER //
// src/views/layouts/Main.vue